import React, { ReactNode } from 'react';

import PageHeaderActionButtons from './PageHeaderActionButtons';
import PageHeaderActionsBar from './PageHeaderActionsBar';
import PageHeaderContainer from './PageHeaderContainer';
import PageHeaderFilters from './PageHeaderFilters';
import PageHeaderGlobalSearcher from './PageHeaderGlobalSearcher';
import {
  PageHeaderActionsOnly,
  PageHeaderTitleOnly,
  PageHeaderWithTitleAndActions,
} from './PageHeaderLayouts';
import PageHeaderMain from './PageHeaderMain';
import PageHeaderQuickActions from './PageHeaderQuickActions';
import PageHeaderTitleSection from './PageHeaderTitleSection';
import PageHeaderToggleGroup from './PageHeaderToggleGroup';
import type { PageHeaderVariant } from './types';

export type {
  PageHeaderIconType,
  PageHeaderIconVariant,
} from './pageHeaderIcons';
export { PAGE_HEADER_ICONS } from './pageHeaderIcons';
export type {
  PageHeaderIconBackground,
  PageHeaderIconColorProps,
  PageHeaderTitleSectionBaseProps,
  PageHeaderTitleSectionProps,
  PageHeaderTitleVariant,
} from './PageHeaderTitleSection';
export type {
  ActionButton,
  ActionChip,
  HeaderActionConfig,
  HeaderActionContext,
  HeaderActionKind,
  PageHeaderVariant,
  ToggleTab,
} from './types';
export { PAGE_HEADER_PADDING } from './types';
export { resolveHeaderActions, useHeaderActions } from './useHeaderActions';

export interface PageHeaderProps {
  children: ReactNode;
  variant?: PageHeaderVariant;
}

const PageHeaderRoot: React.FC<PageHeaderProps> = ({
  children,
  variant = 'pageHeader',
}) => {
  return (
    <PageHeaderContainer variant={variant}>{children}</PageHeaderContainer>
  );
};

const PageHeader = Object.assign(PageHeaderRoot, {
  Main: PageHeaderMain,
  TitleSection: PageHeaderTitleSection,
  ActionButtons: PageHeaderActionButtons,
  GlobalSearcher: PageHeaderGlobalSearcher,
  ActionsBar: PageHeaderActionsBar,
  ToggleGroup: PageHeaderToggleGroup,
  QuickActions: PageHeaderQuickActions,
  Filters: PageHeaderFilters,
  // Layout presets
  WithTitleAndActions: PageHeaderWithTitleAndActions,
  ActionsOnly: PageHeaderActionsOnly,
  TitleOnly: PageHeaderTitleOnly,
});

export default PageHeader;
export {
  PageHeaderActionButtons,
  PageHeaderActionsBar,
  PageHeaderActionsOnly,
  PageHeaderFilters,
  PageHeaderGlobalSearcher,
  PageHeaderMain,
  PageHeaderQuickActions,
  PageHeaderTitleOnly,
  PageHeaderTitleSection,
  PageHeaderToggleGroup,
  PageHeaderWithTitleAndActions,
};
export type {
  PageHeaderActionsOnlyProps,
  PageHeaderTitleOnlyProps,
  PageHeaderWithTitleAndActionsProps,
} from './PageHeaderLayouts';
